// LoginPage.jsx
import React, { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../hooks/useAuth";
import { useSelector } from "react-redux";
import { logger } from "helpers/logger";

logger.info('🔐 LoginPage loaded, URL:', window.location.href);

export default function LoginPage({ loginKeycloakIframeFlag }) {
    const keycloakAuth = useAuth();
    const navigate = useNavigate();
    const { data: domainData } = useSelector(state => state.domainConfig);
    logger.info('LoginPage loginKeycloakIframeFlag: ', loginKeycloakIframeFlag);

    useEffect(() => {
        if (!keycloakAuth.isLoading && keycloakAuth.isAuthenticated) {
            logger.info('✅ Already authenticated, redirecting to /userCompanies');
            navigate('/userCompanies');
            return;
        }

        if (!keycloakAuth.isLoading && loginKeycloakIframeFlag === false) {
            logger.info('🚀 loginKeycloakIframeFlag is false, redirecting to Keycloak login page');
            keycloakAuth.login();
        }
    }, [keycloakAuth, loginKeycloakIframeFlag, navigate]);

    if (loginKeycloakIframeFlag === false) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    flexDirection: 'column',
                    gap: 2
                }}
            >
                <CircularProgress />
                <div>Redirecting to login...</div>
            </Box>
        );
    }

    logger.info('🖼️ Rendering Keycloak login iframe');
    const keycloakLoginUrl = keycloakAuth.createLoginUrl(`${window.location.origin}/auth/callback`);

    /* return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                height: '100%', // Use 100% of parent container
            }}
        >
            
            <Box
                sx={{
                    width: '50%',
                    height: '100%', // Use 100% of parent
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'background.default'
                }}
            >
                <Box
                    component="img"
                    src={domainData?.LoginImage}
                    alt="Login"
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                />
            </Box>

            
            <Box
                sx={{
                    width: '50%',
                    height: '100%', // Use 100% of parent
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <Box
                    component="iframe"
                    src={keycloakLoginUrl}
                    title="Keycloak Login"
                    sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation allow-modals"
                    sx={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        display: 'block'
                    }}
                />
            </Box>
        </Box>
    ); */

    /*    return (
           
           <Box
               sx={{
                   width: "100%",
                   height: "100vh",
                   display: "flex",
                   flexDirection: { xs: "column", md: "row" },
                   //overflow: "hidden",
                   margin: 0,
                   padding: 0,
               }}
           >
               <Box
                   component="img"
                   src={domainData?.LoginImage}
                   sx={{
                       width: { xs: "100%", md: "50%" },
                       height: "100%",
                       objectFit: "cover",
                   }}
               />
   
               <Box
                   component="iframe"
                   src={keycloakLoginUrl}
                   sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation allow-modals"
                   sx={{
                       width: { xs: "100%", md: "50%" },
                       height: "100%",
                       border: "none",
                       //overflow: "hidden",
                   }}
               />
           </Box>
       ); */

    return (
        <Box sx={{ display: "flex", width: "100%", height: "100%" }}>
            <Box
                component="img"
                src={domainData?.loginImage}
                sx={{
                    width: "50%",
                    height: "100%",
                    objectFit: "cover",
                    flexShrink: 0
                }}
            />

            <Box
                component="iframe"
                src={keycloakLoginUrl}
                sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation allow-modals"
                sx={{
                    width: "50%",
                    height: "100%",
                    border: "none",
                    flexShrink: 0
                }}
            />
        </Box>

    );
}